import Datepicker from "stimulus-datepicker"

const chineseWeekdays = ["日", "一", "二", "三", "四", "五", "六"]
const englishWeekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

export default class extends Datepicker {
  dayNames() {
    const userLanguage = navigator.language || navigator.userLanguage
    const isChinese = userLanguage.startsWith("zh")
    const weekdays = isChinese ? chineseWeekdays : englishWeekdays
    const firstDay = this.firstDayOfWeekValue
    return weekdays.slice(firstDay).concat(weekdays.slice(0, firstDay))
  }
}
